import React from 'react';
import { PropTypes } from 'prop-types';

import AccessControl from 'components/AccessControl';
import ActivityPerms from 'components/AccessControl/permissions.json';
import BatchFileFormsButton from 'components/Common/Buttons/BatchFileFormsButton';

// eslint-disable-next-line import/prefer-default-export
export const BatchFileActionsCellRenderer = ({
  value: id,
  data: batchFile,
  context: {
    settings,
    permissions,
    editCustomerLegalEntitiesCallback,
    downloadOriginalBatchFileCallback,
    deleteFileCallback
  }
}) => (
  <div className="form-action-btn-group">
    { batchFile.id && batchFile.numberOfForms != null && batchFile.numberOfForms > 0 && <BatchFileFormsButton
      batchId={ batchFile.batchId }
      batchFileId={ batchFile.id }
      content={ <span className="icon icon-copy" /> }
      className="btn btn-sm"
      title="View Forms"
    /> }
    { batchFile && AccessControl.hasPermission(permissions, [ActivityPerms.scannedDownload])
      && <button
        type="button"
        className="btn btn-sm btn-action"
        onClick={ () => downloadOriginalBatchFileCallback(batchFile) }
        title="Download Original Batch File"
      >
        <span className="icon icon-download" />
      </button> }
    { AccessControl.hasPermission(permissions, [ActivityPerms.fwfBatchReviewer]) && <button
      className="btn btn-sm btn-danger"
      onClick={ () => deleteFileCallback(batchFile.id) }
      type="button"
      title="Delete File"
    >
      <span className="icon icon-delete" />
    </button> }
    { settings && batchFile.id && batchFile.id !== '' && batchFile.customers != null && batchFile.customers.length > 0
    && AccessControl.hasPermission(permissions, [ActivityPerms.fwfBatchReviewer])
    && <span><button
      className="btn btn-sm "
      onClick={ () => editCustomerLegalEntitiesCallback(batchFile.customers) }
      type="button"
      title="Edit Legal Entity"
    >
      <span className="icon icon-edit" />
    </button></span> }
  </div>
);

BatchFileActionsCellRenderer.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]).isRequired,
  data: PropTypes.shape({
    id: PropTypes.number,
    batchId: PropTypes.number,
    batchType: PropTypes.string,
    isOnlineForm: PropTypes.bool,
    numberOfForms: PropTypes.number,
    customers: PropTypes.arrayOf(PropTypes.shape()),
  }).isRequired,
  context: PropTypes.shape({
    settings: PropTypes.shape(),
    permissions: PropTypes.arrayOf(PropTypes.string),
    editLegalEntityCallback: PropTypes.func,
    downloadOriginalBatchFileCallback: PropTypes.func,
    editCustomerLegalEntitiesCallback: PropTypes.func,
    deleteFileCallback: PropTypes.func,
  })
};

BatchFileActionsCellRenderer.defaultProps = {
  context: {}
};
